import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_URL, DEFAULT_META, ROUTE_META, OG_IMAGE, OG_IMAGE_ALT, SHARE_TITLE, SHARE_DESCRIPTION } from '../../data/siteSeo';

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const pathToCanonical = (pathname) => {
  if (pathname === '/') return `${SITE_URL}/`;
  return `${SITE_URL}${pathname}`;
};

const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname] || DEFAULT_META;
    const canonical = pathToCanonical(pathname);

    document.title = meta.title;
    setMeta('name', 'description', meta.description);
    setMeta('name', 'keywords', 'PSAG Church, Philadelphia Shalem Assembly of God, Malayalee church Philadelphia, Pentecostal church Philadelphia, Assemblies of God Philadelphia');

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'PSAG Church');
    setMeta('property', 'og:title', pathname === '/' ? SHARE_TITLE : meta.title);
    setMeta('property', 'og:description', pathname === '/' ? SHARE_DESCRIPTION : meta.description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:image', OG_IMAGE);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');
    setMeta('property', 'og:image:alt', OG_IMAGE_ALT);
    setMeta('property', 'og:locale', 'en_US');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', pathname === '/' ? SHARE_TITLE : meta.title);
    setMeta('name', 'twitter:description', pathname === '/' ? SHARE_DESCRIPTION : meta.description);
    setMeta('name', 'twitter:image', OG_IMAGE);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonical);
  }, [pathname]);

  return null;
};

export default Seo;
